
import { apiFetch } from './apiFetch';

async function loginUser(username, password) {
  const url = `${process.env.REACT_APP_API_URL}/Auth/loginMobile`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({ username, password })
    });
    
    const data = await response.json();

    if (!response.ok) {
      return { isSuccess: false, errors: data.errors || [], message: data.message || 'Login failed' };
    }

    return data; 
  } catch (error) {
    throw error;
  }
}

async function forgotPassword(payload) {
  const url = `${process.env.REACT_APP_API_URL}/Auth/forgot-password`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json().catch(() => null);

    if (!response.ok) {
      return {
        isSuccess: false,
        errors: data?.errors || [],
        message: data?.message || 'Unable to submit forgot password request.'
      };
    }

    return {
      isSuccess: true,
      message: data?.message || 'If the account exists, reset instructions will be emailed shortly.',
      data
    };
  } catch (error) {
    throw error;
  }
}

async function resetForgottenPassword(payload) {
  const url = `${process.env.REACT_APP_API_URL}/Auth/reset-password`;

  try {
      const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json().catch(() => null);

    if (!response.ok) {
      return {
        isSuccess: false,
        errors: data?.errors || [],
        message: data?.message || 'Unable to reset password.'
      };
    }

    return {
      isSuccess: true,
      message: data?.message || 'Your password has been reset successfully.',
      data
    };
  } catch (error) {
    throw error;
  }
}

async function logoutUser(token) {
  const url = `${process.env.REACT_APP_API_URL}/Auth/logout`;

  try {
    const response = await fetch(url, {
      method: 'POST',      
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return { message: 'Logout successful' };
  } catch (error) {
    throw error;
  }
}

async function keepAlive() {
  const url = process.env.REACT_APP_SESSION_KEEPALIVE_URL || `${process.env.REACT_APP_API_URL}/Site`;

  const response = await apiFetch(url, {
    method: 'GET',
    cache: 'no-store',
  });

  if (!response.ok) {
    throw new Error(`Keepalive failed with status: ${response.status}`);
  }
}

const AuthService = { loginUser, forgotPassword, resetForgottenPassword, logoutUser, keepAlive };

export default AuthService;
